var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsitePages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website pages"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.429 9.81873L2.25 12.0687L6.429 14.3187M6.429 9.81873L12 12.8187L17.571 9.81873M6.429 9.81873L2.25 7.56873L12 2.31873L21.75 7.56873L17.571 9.81873M6.429 14.3187L2.25 16.5687L12 21.8187L21.75 16.5687L17.571 14.3187M6.429 14.3187L12 17.3187L17.571 14.3187M17.571 9.81873L21.75 12.0687L17.571 14.3187",
    stroke: "#E8E9E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsitePages);
export default __webpack_public_path__ + "static/media/websitePages.01522e037275b9e1e3d8ba70091c5fed.svg";
export { ForwardRef as ReactComponent };